//@ts-ignore
import { combineReducers } from "redux";
import Ambassador from "./Ambassador";


const appReducer = combineReducers({
    Ambassador
});
// @ts-ignore
export const rootReducer = (state, action) => {
  return appReducer(state, action);
};